import { render } from "./MerchantStores.vue?vue&type=template&id=bb955b82&scoped=true&ts=true"
import script from "./MerchantStores.vue?vue&type=script&lang=ts"
export * from "./MerchantStores.vue?vue&type=script&lang=ts"

import "./MerchantStores.vue?vue&type=style&index=0&id=bb955b82&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb955b82"]])

export default __exports__